import { RootState } from "@/modules/common";

export const selectProducts = (state: RootState) => state.products;
